import { isEmpty } from 'lodash/fp';
import classnames from 'classnames/bind';
import { NotAvailable } from './NotAvailable.jsx';
import * as styles from './WarehouseLoadDialog.css';

const cx = classnames.bind(styles);

export function NameTag({ value }) {
    if (isEmpty(value)) {
        return <NotAvailable />;
    }

    return <div className={cx('name-tag')}>{value}</div>;
}
